"use client";

import TeamMatchupCard from "@/components/headToHead/Header/TeamMatchupCard/TeamMatchupCard";
import { TIME_IN_MS } from "@/constants/time";
import { EventStatus, GetHeadToHeadHeaderQuery } from "@/graphql/gql/graphql";
import { useHeadToHeadContext } from "@/utils/hooks/useHeadToHeadContext";
import useLiveCoreOdds from "@/utils/hooks/useLiveCoreOdds";
import styles from "./teamMatchups.module.scss";

interface TeamMatchupsProps {
  headerData: GetHeadToHeadHeaderQuery["event"];
}

export default function TeamMatchups({ headerData }: TeamMatchupsProps) {
  const { gameId, gameState, awayTeam, homeTeam } = useHeadToHeadContext();
  const shouldRefetch = gameState === EventStatus.Live;
  const reactQueryOptions = {
    initialData: {
      event: {
        odds: headerData?.odds,
      },
    },
    enabled: shouldRefetch,
    refetchInterval: shouldRefetch ? TIME_IN_MS.SEC_30 : undefined,
  };
  const { data } = useLiveCoreOdds(gameId, reactQueryOptions);

  const odds = data?.event?.odds;

  return (
    <div className={styles.container}>
      <TeamMatchupCard
        team={awayTeam}
        odds={odds}
        oddsResult={headerData?.oddsResult}
        resultKey="away"
        rawRecord={headerData?.awayTeam?.record}
      />

      <span className={styles.atSymbol}>@</span>

      <TeamMatchupCard
        team={homeTeam}
        odds={odds}
        oddsResult={headerData?.oddsResult}
        resultKey="home"
        rawRecord={headerData?.homeTeam?.record}
      />
    </div>
  );
}
